import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types.tsx';

export const EARLIEST = 'EARLIEST' as const;
export const LATEST = 'LATEST' as const;
export const SUM = 'SUM' as const;
export const LIST_ALL = 'LIST_ALL' as const;

export type AggregateType = typeof EARLIEST | typeof LATEST | typeof SUM | typeof LIST_ALL;

export type OwnProps = {
	groupName: string;
	id: string;
};

export type AggregateValue = {
	startDate?: number | undefined | null;
	dueDate: number | undefined | null;
	targetStart: number | undefined | null;
	targetEnd: number | undefined | null;
	storyPoints: number | undefined | null;
	timeEstimate: number | undefined | null;
	status: string[];
	assignee: string[];
};

export type AggregateTypes = { [key: string]: AggregateType };

export type ValueType =
	| { fieldKey: 'status' | 'assignee'; value: string[]; type: AggregateType }
	| {
			fieldKey:
				| 'startDate'
				| 'dueDate'
				| 'targetStart'
				| 'targetEnd'
				| 'storyPoints'
				| 'timeEstimate';
			value: number | undefined;
			type: AggregateType;
	  };

export type StateProps = {
	field: ValueType | undefined;
};

export type MapStateToProps = (state: State, ownProps: OwnProps) => StateProps;
export type Props = StateProps & OwnProps;
